import BaseApi from "./BaseApi";

export function getDiaryDates(siteId, period) {
  const params = { siteId };
  if (period) {
    params.period = period;
  }
  return BaseApi.get("/diaries/dates", { params });
}

export function getDiaryRevision(siteId, objDateDiary, period) {
  const params = {
    siteId: siteId,
    year: objDateDiary.year,
    month: objDateDiary.month,
    day: objDateDiary.day,
    period: period,
  };
  const URL_DIARY_DETAIL = "/diaries/details";

  return BaseApi.get(URL_DIARY_DETAIL, {
    params: params,
  });
}
